import _extends from "babel-runtime/helpers/extends";
import uuidV4 from "uuid/v4";
import { SRE_CANCEL_SESSION } from "../../sreactions";
import SreReadingTracker from ".";

export var initialState = {
  readingtracker: {
    status: "init",
    sessionId: 0,
    // reading tracker
    text: null,
    silence: null,
    canceled: null,
    soundLog: null,
    soundObj: null,
    useGrammar: null,
    finalResult: null,
    sessionData: null,
    // new in reading tracker progress v2
    isResultAvailable: false,
    currentSpeakingWordIndex: null,
    // new in reading tracker result v2
    gradedWords: null,
    finalScore: null,
    hypothesis: null,
    // Playback Session
    playbackData: null,
    playbackIsPlaying: null,
    playbackInterrupted: null,
    playbackCurrentTime: null,
    playbackStartTime: null,
    playbackTotalTime: null,
    playbackIsComplete: null
  }
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SreReadingTracker.READING_TRACKER_SESSION_START_V2:
      return _extends({}, state, {
        audioLevel: 0,
        listening: true,
        readingtracker: _extends({}, initialState.readingtracker, {
          status: "sessionTrackerStart",
          text: action.payload.text || null,
          sessionId: action.payload.sessionId || uuidV4(),
          useGrammar: action.payload.useGrammar === true
        })
      });

    case SreReadingTracker.READING_TRACKER_SESSION_PROGRESS_V2:
      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          status: "sessionTrackerProgress",
          isResultAvailable: false, // @MAYBE_FIXME - this seems like a fair assumption for now ...
          currentSpeakingWordIndex: action.payload.currentSpeakingWordIndex
        })
      });

    case SreReadingTracker.READING_TRACKER_SESSION_RESULT_V2:
      if (action.payload.canceled === true) {
        return _extends({}, state, {
          readingtracker: _extends({}, initialState.readingtracker, {
            status: "sessionTrackerResultCancel",
            canceled: true,
            isResultAvailable: false
          })
        });
      } else {
        var _action$payload = action.payload,
            gradedWords = _action$payload.gradedWords,
            finalScore = _action$payload.finalScore,
            hypothesis = _action$payload.hypothesis;

        var silence = action.payload.silence === true;
        return _extends({}, state, {
          audioLevel: 0,
          listening: false,
          readingtracker: _extends({}, state.readingtracker, {
            status: "sessionTrackerResult",
            canceled: false,
            silence: silence,
            isResultAvailable: true,
            gradedWords: gradedWords,
            finalScore: finalScore,
            hypothesis: hypothesis
          })
        });
      }

    case SreReadingTracker.READING_TRACKER_SESSION_RESET:
      return _extends({}, state, {
        audioLevel: 0,
        listening: false,
        readingtracker: _extends({}, initialState.readingtracker, {
          status: "sessionReset"
        })
      });

    case SreReadingTracker.READING_TRACKER_SESSION_STORE_SOUND:
      var soundObj = action.payload.soundObj || null;
      var soundLog = action.payload.soundLog || null;
      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          status: "sessionStoreSound",
          soundObj: soundObj,
          soundLog: soundLog
        })
      });

    // =======================
    // Play Back Reducers
    // =======================

    case SreReadingTracker.READING_TRACKER_PLAYBACK_START_V2:
      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          status: "sessionPlaybackStart",
          playbackIsPlaying: true,
          playbackInterrupted: false,
          playbackIsComplete: false,
          playbackStartTime: action.payload.startTime
        })
      });

    case SreReadingTracker.READING_TRACKER_PLAYBACK_SEEK_TIME:
      var currentTime = state.readingtracker.playbackCurrentTime || 0;
      var rewindTime = currentTime + action.payload.time;
      var newTime = rewindTime < 0 ? 0 : rewindTime;

      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          playbackCurrentTime: newTime,
          playbackIsPlaying: true
        })
      });

    case SreReadingTracker.READING_TRACKER_PLAYBACK_PROGRESS:
      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          status: "sessionPlaybackProgress",
          playbackData: action.payload.progress,
          playbackCurrentTime: action.payload.currentTime
        })
      });

    case SreReadingTracker.READING_TRACKER_PLAYBACK_INTERRUPT:
      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          status: "sessionPlaybackInterrupt",
          playbackIsPlaying: false,
          playbackInterrupted: true
        })
      });

    case SreReadingTracker.READING_TRACKER_PLAYBACK_END:
      return _extends({}, state, {
        readingtracker: _extends({}, state.readingtracker, {
          status: "sessionPlaybackEnd",
          playbackIsPlaying: false,
          playbackIsComplete: true
        })
      });

    // =======================
    // CANCEL Session
    // =======================

    case SRE_CANCEL_SESSION:
      return _extends({}, state, {
        listening: false,
        audioLevel: 0,
        readingtracker: _extends({}, initialState.readingtracker, {
          status: "sessionCancel",
          canceled: true
        })
      });

    default:
      return state;
  }
};

export default reducer;